import { StrapiLocale } from "@hooks";
import { ApiRoutes } from "@routes";
import { AllBlogPostsQuery, AllCaseStudiesQuery, AllNewsEventsQuery } from "gql";

export interface RecommendedPostArgs {
  categorySlug: string;
  excludedId: string;
  publishDate: string;
}

class StrapiClientRequestsService {
  private config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  private query = async <Type>(route: keyof typeof ApiRoutes, args: unknown) => {
    const fetchResponse = await fetch(ApiRoutes[route], {
      method: "POST",
      body: JSON.stringify(args),
      headers: this.config.headers,
    });

    const response = await fetchResponse.json();

    return response as Type;
  };

  getBlogs = async (args: { locale?: StrapiLocale; pagination: any; filters: any }) =>
    this.query<AllBlogPostsQuery["blogPosts"]["data"][number]["attributes"][]>("strapiBlogs", args);

  getCaseStudies = async (args: { locale?: StrapiLocale; pagination: any; filters: any }) =>
    this.query<AllCaseStudiesQuery["caseStudies"]["data"][number]["attributes"][]>(
      "strapiCaseStudies",
      args,
    );

  getNewsEvents = async (args: { locale?: StrapiLocale; pagination: any; filters: any }) =>
    this.query<AllNewsEventsQuery["newsAndEvents"]["data"][number]["attributes"][]>(
      "strapiNewsEvents",
      args,
    );
}

export const strapiClientRequestsService = new StrapiClientRequestsService();
